module.exports = __webpack_public_path__ + "static/media/barcode.40d791ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/barcode.svg
// module id = 1393
// module chunks = 0